import { PUBLIC_EMAIL_DOMAINS_LIST } from '../constants'

const isPublicEmail = email => {
  if (email?.trim?.()) {
    return PUBLIC_EMAIL_DOMAINS_LIST.includes(email.split('@').pop())
  }

  return false
}

export { isPublicEmail }
